import { NgClass, SlicePipe } from '@angular/common';
import {
	ChangeDetectionStrategy,
	Component,
	input,
	ViewEncapsulation,
} from '@angular/core';

import { TranslatePipe } from '@ngx-translate/core';
import { AngularSvgIconModule } from 'angular-svg-icon';

import { SheetModule } from '@valk-nx/components/ui-sheet/src/lib/sheet.module';
import { HeadingDirective } from '@valk-nx/core/lib/directives/heading/heading.directive';
import type { HeadingType } from '@valk-nx/core/lib/directives/heading/heading.type';

@Component({
	changeDetection: ChangeDetectionStrategy.OnPush,
	encapsulation: ViewEncapsulation.None,
	imports: [
		AngularSvgIconModule,
		HeadingDirective,
		NgClass,
		SlicePipe,
		TranslatePipe,
		SheetModule,
	],
	host: { ngSkipHydration: 'true' },
	selector: 'vp-list-grid',
	templateUrl: './list-grid.html',
})
export class ListGridComponent {
	name = input.required<string>();
	listItems = input.required<string[]>();

	sheetTitle = input<string>();
	title = input<string>();
	useCol2 = input<boolean>(true);
	headingType = input<HeadingType>('h3');
}
